<template>
    <div class="content-box">
        <Title/>
        <div class="title-right">
      <el-link href="https://www.100ec.cn/Index/wjsqdws.html" target='_blank'>
        <img src="https://www.100ec.cn/Public/home/images/dd.gif"
      /></el-link>
      
    </div>
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(i, index) of dataNav"
            :key="index"
            @click="handleSelect(index)">
            {{i.label}}</el-menu-item>
        </el-menu>

        <div class="mobile-select">
            <el-select
            v-model="name"
            @change="handleSelect2">
                <el-option
                v-for="item in dataNav"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "broadCast",
    data() {
        return {
            activeIndex: '1',
            name: '滚动播报',
            dataNav: [
                {
                    value: '直播',
                    label: '滚动播报'
                },
                {
                    value: '直播间',
                    label: '直播间'
                },
                {
                    value: '主播',
                    label: '主播'
                },
                {
                    value: '带货',
                    label: '带货'
                },
                {
                    value: 'MCN',
                    label: 'MCN'
                },
                {
                    value: '直播 翻车',
                    label: '直播翻车'
                },
                {
                    value: '直播 运营',
                    label: '直播运营'
                },
                {
                    value: '二手 直播',
                    label: '二手直播'
                },
                {
                    value: '农村 直播',
                    label: '农村直播'
                },
                {
                    value: '母婴 直播',
                    label: '母婴直播'
                },
                {
                    value: '美妆 直播',
                    label: '美妆直播'
                },
                {
                    value: '食品 直播',
                    label: '食品直播'
                },
                {
                    value: '服装 直播',
                    label: '服装直播'
                },
                {
                    value: '汽车 直播',
                    label: '汽车直播'
                },
                {
                    value: '跨境 直播',
                    label: '跨境直播'
                },
                {
                    value: '旅游 直播',
                    label: '旅游直播'
                },
                {
                    value: '教育 直播',
                    label: '教育直播'
                },
                {
                    value: '明星 直播',
                    label: '明星直播'
                },
                {
                    value: '达人',
                    label: '达人'
                },
                {
                    value: '探店',
                    label: '探店'
                },
                {
                    value: '董宇辉',
                    label: '董宇辉'
                },
                {
                    value: '薇娅',
                    label: '薇娅'
                },
                {
                    value: '李佳琦',
                    label: '李佳琦'
                },
                {
                    value: '辛巴',
                    label: '辛巴'
                },
                {
                    value: '罗永浩',
                    label: '罗永浩'
                },
                {
                    value: '雪梨',
                    label: '雪梨'
                },
                {
                    value: '张大奕',
                    label: '张大奕'
                },
                {
                    value: '丁磊 直播',
                    label: '丁磊'
                },
                {
                    value: '董明珠 直播',
                    label: '董明珠'
                },
                {
                    value: '梁建章 直播',
                    label: '梁建章'
                },
            ],
            params: {
                json: 0,
                filter: [
                    "【",
                    "研报",
                    "分析",
                    "（PPT）",
                    "（全文）",
                    "曹磊",
                    "莫岱青",
                    "蒙慧欣",
                    "鲍跃忠",
                    "黄伟",
                ]
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', this.dataNav[0].value)
        this.$store.dispatch('getText')
    },
    methods: {
        handleSelect(index) {
            this.$store.commit('changeKeys', this.dataNav[index].value)
            this.$store.dispatch('getText')
        },
        handleSelect2(value) {
            this.$store.commit('changeKeys', value)
            this.$store.dispatch('getText')
        },
    },
};
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>